import React, { PropsWithChildren } from 'react';
import Tooltip from 'js/components/elements/mui/Tooltip';
import { ReactComponent as InfoSvg } from 'new/components/icons/fi-rr-info.svg';
import classes from './InfoIconInline.module.scss';
import cx from 'classnames';

type InfoIconInlineProps = {
  title: React.ReactNode;
  placement?: string;
  className?: string;
};

export const InfoIconInline = (props: PropsWithChildren<InfoIconInlineProps>) => {
  const { title, placement = 'right', className } = props;
  const TooltipAny = Tooltip as any;
  return (
    <TooltipAny placement={placement} tooltipTheme="fieldInfo" title={title}>
      <span className={cx(classes.inlineIcon, className)}>
        <InfoSvg className={classes.icon} />
      </span>
    </TooltipAny>
  );
};

export default InfoIconInline;
